import React, { Component } from "react";
import "./SamplePassport.scss";
import VoterIDFront from "../../../assets/docSampleImages/Passport Front.jpg";
import VoterIDBack from "../../../assets/docSampleImages/Passport Back.jpg";
export interface IViewSamplePassportPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
}
const SamplePassportPopup = (props: IViewSamplePassportPopup) => {
  const popupRefFive = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (popupRefFive.current !== null && popupRefFive.current !== undefined) {
        props?.setShowPopup(); // Close popup if clicked outside
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);

  return (
    <div
      className={`overlay-Passport ${props?.parentClassName ?? ""}`}
      ref={popupRefFive}
    >
      <div className="popup-Passport">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Uploading Passport</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}

        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Passport in JPEG or
              PNG (Max Size: 2MB)
            </p>
            <span className="passport-row">
              <span className="Aadhar-Front-row">
                <div className="image-container">
                  <img
                    src={VoterIDFront}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image"
                  />
                  <div className="badge">1</div>
                </div>

                <label className="Aadhar-Label">FRONT</label>
              </span>
              <span className="Aadhar-Front-row mgl-20">
                <div className="image-container">
                  <img
                    src={VoterIDBack}
                    width={100}
                    height={100}
                    className="aadhar-Front-sample document-image"
                  />
                  <div className="badge">2</div>
                </div>

                <label className="Aadhar-Label">BACK</label>
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};
export default SamplePassportPopup;
